import { useState } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Courses from "@/components/site/Courses";
import Consultancy from "@/components/site/Consultancy";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Faculty from "@/components/site/Faculty";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import Colleges from "@/components/site/Colleges";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import EnquiryModal from "@/components/site/EnquiryModal";
import { useContent } from "@/context/ContentContext";
import { MessageCircle } from "lucide-react";

export default function Home() {
  const { content, loading } = useContent();
  const [modalOpen, setModalOpen] = useState(false);

  if (loading || !content) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#FDFBF7]" data-testid="home-loading">
        <div className="text-center">
          <div className="w-12 h-12 mx-auto rounded-full border-4 border-[#1E3A8A]/20 border-t-[#1E3A8A] animate-spin" />
          <div className="mt-4 text-sm text-slate-500">Loading Sunbright Pharma Academy...</div>
        </div>
      </div>
    );
  }

  const s = content.sections || {};
  const branding = content.branding || {};
  const open = () => setModalOpen(true);

  return (
    <div id="top" className="bg-[#FDFBF7]" data-testid="home-root">
      <Header onEnquire={open} />
      {s.hero?.visible !== false && <Hero data={s.hero} branding={branding} onEnquire={open} />}
      {s.about?.visible !== false && <About data={s.about} branding={branding} onEnquire={open} />}
      {s.courses?.visible !== false && <Courses data={s.courses} onEnquire={open} />}
      {s.consultancy?.visible !== false && <Consultancy data={s.consultancy} />}
      {s.whyChooseUs?.visible !== false && <WhyChooseUs data={s.whyChooseUs} />}
      {s.faculty?.visible !== false && <Faculty data={s.faculty} />}
      {s.gallery?.visible !== false && <Gallery data={s.gallery} />}
      {s.testimonials?.visible !== false && <Testimonials data={s.testimonials} />}
      {s.colleges?.visible !== false && <Colleges data={s.colleges} />}
      {s.contact?.visible !== false && <Contact data={s.contact} branding={branding} />}
      <Footer />

      {/* Floating CTA */}
      <button
        onClick={open}
        data-testid="floating-enquire-btn"
        className="fixed bottom-6 right-6 z-40 btn-accent !rounded-full !px-5 !py-3.5 cta-pulse"
      >
        <MessageCircle className="w-4 h-4" /> Enquire Now
      </button>

      <EnquiryModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  );
}
